import { Suspense } from 'react';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import * as Sentry from '@sentry/react';
import 'core-js/stable';
import { createRoot } from 'react-dom/client';
import HttpsRedirect from 'react-https-redirect';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { Loading } from './components/Loading/Loading';

import App from './App';
import './helpers/string';
import './i18n';
import { store } from './store';
import './styles/app.scss';

String.prototype.Capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

library.add(fas);

if (process.env.REACT_APP_ENV === 'prod') {
  Sentry.init({
    dsn: 'https://06170c20d1d2772e1202fa8040015f8e@o4506547871547392.ingest.us.sentry.io/4509792693583872',
    environment: 'prod',
    release: process.env.REACT_APP_RELEASE,
    sendDefaultPii: true,
  });
}

const root = createRoot(document.getElementById('App'));
root.render(
  <Provider store={store}>
    <HttpsRedirect>
      <BrowserRouter basename="/">
        <Suspense fallback={<Loading active={true} />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </HttpsRedirect>
  </Provider>,
);
